import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StorageService {

  get<T>(key: string, fallback: T): T {
    try {
      const raw = localStorage.getItem(key);
      if (raw === null) return fallback;
      return JSON.parse(raw) as T;
    } catch {
      return fallback;
    }
  }

  getString(key: string, fallback: string | null = null): string | null {
    try {
      return localStorage.getItem(key) ?? fallback;
    } catch {
      return fallback;
    }
  }

  set(key: string, value: unknown): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch { /* quota exceeded or private browsing */ }
  }

  setString(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch { /* quota exceeded or private browsing */ }
  }

  remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch { /* private browsing */ }
  }
}
